"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Checkbox_1 = __importDefault(require("../common/Checkbox"));
var react_i18next_1 = require("react-i18next");
var LEGACY_MODAL_KEY = "hideLegacyModal";
var LegacyModal = function (_a) {
    var isShown = _a.isShown, onClose = _a.onClose;
    var _b = (0, react_1.useState)(false), hideLegacyModal = _b[0], setHideLegacyModal = _b[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var handleCheckboxChange = function () {
        setHideLegacyModal(!hideLegacyModal);
    };
    var handleModalClose = function () {
        if (hideLegacyModal) {
            localStorage.setItem(LEGACY_MODAL_KEY, "true");
        }
        onClose();
    };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: handleModalClose, headerText: t("Legacy integrations"), body: react_1.default.createElement("div", null,
            react_1.default.createElement("p", null,
                t("A new version of integrations has been introduced"),
                "."),
            react_1.default.createElement("p", null,
                t("You can still access your currently running integrations here"),
                ":"),
            react_1.default.createElement("a", { href: "/integrations/legacy", style: { color: "#507C7D" } }, t("Go to your currently running integrations")),
            react_1.default.createElement("div", { style: { marginTop: "1rem" } },
                react_1.default.createElement(Checkbox_1.default, { id: "dont-show-again", checked: hideLegacyModal, onChange: handleCheckboxChange, style: { padding: "0" } }),
                react_1.default.createElement("label", { htmlFor: "dont-show-again", style: { marginLeft: "0.5rem", color: "var(--info-color)", fontWeight: "600" } }, t("Don't show this again")))), footer: react_1.default.createElement("div", null,
            react_1.default.createElement(q_play_components_1.Button, { onClick: handleModalClose, text: t("Close") })), centered: true }));
};
exports.default = LegacyModal;
